import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  height: auto;

  p {
    cursor: pointer;
    :hover {
      color: ${(props) => props.theme.primary.light};
      transition: 0.4s;
    }

    svg {
      margin-right: 10px;
      vertical-align: middle;
    }
  }
`;

export const DaysContainer = styled.div`
  margin: 25px 0px;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`;

export const DateButton = styled.button<{ selected?: boolean }>`
  width: 100px;
  border: 0;
  border-radius: 4px;
  height: 30px;
  color: ${({ selected }) => (selected ? "white" : "#444")};
  background: ${({ selected, theme }) => (selected ? theme.primary.light : "transparent")};
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
`;

export const FilterContent = styled.div`
  display: flex;
  margin-top: 20px;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  color: #444;

  form {
    flex-wrap: wrap;
    gap: 10px;
    display: flex;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 12px;

  .title {
    flex: 0 0 30%;
  }

  .actions {
    flex: 1 1 70%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;

    .title,
    .actions {
      flex: 0 0 auto;
      width: 100%;
    }

    .actions {
      justify-content: flex-start;
      margin-top: 8px;
    }
  }
`;
